/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-info[_ngcontent-%COMP%]{border:1px solid rgba(0,0,0,.125);padding:.5rem;display:-webkit-box;display:flex}.center-right[_ngcontent-%COMP%]{vertical-align:middle;float:right}@media (min-width:768px){.box-info[_ngcontent-%COMP%]{width:32rem}}"];
export { styles as styles };
